import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine, FadeUp } from "@/components/Reveal";
import MagneticButton from "@/components/MagneticButton";

export default function CTABanner() {
    const navigate = useNavigate();

    return (
        <section
            data-testid="cta-banner"
            className="relative overflow-clip border-t border-white/[0.07] py-32 sm:py-40"
        >
            <div className="blueprint-grid pointer-events-none absolute inset-0 opacity-25 [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
            <div className="relative mx-auto flex max-w-7xl flex-col items-start px-6 sm:px-10">
                <FadeUp y={20}>
                    <p className="flex items-center gap-4 text-[10px] font-medium uppercase tracking-[0.45em] text-ash">
                        <span className="h-px w-10 bg-gold" />
                        Your site is waiting
                    </p>
                </FadeUp>
                <h2 className="mt-8 font-display text-[clamp(2.25rem,10vw,4.5rem)] font-black uppercase leading-[0.95] tracking-tight [word-break:break-word] sm:text-6xl md:text-7xl">
                    <MaskedLine delay={0.05}>Let's Build</MaskedLine>
                    <MaskedLine delay={0.15}>
                        <span className="text-gold">Extraordinary</span>
                    </MaskedLine>
                </h2>
                <FadeUp delay={0.3} className="mt-12">
                    <MagneticButton>
                        <button
                            data-testid="cta-banner-btn"
                            onClick={() => navigate("/contact")}
                            className="group flex items-center gap-3 rounded-full bg-gold px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-coal transition-colors duration-300 hover:bg-white"
                        >
                            Start Project
                            <ArrowUpRight
                                size={16}
                                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                            />
                        </button>
                    </MagneticButton>
                </FadeUp>
            </div>
        </section>
    );
}
